"use client";
import * as l from "react";
import { u as w } from "./useEventCallback-CjuAhyNz.mjs";
import { u as T } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as k } from "./CompositeRootContext-Eb_XU-qm.mjs";
import { m as K, d as B } from "./useRenderElement-B8V3_e8R.mjs";
let D;
process.env.NODE_ENV !== "production" && (D = /* @__PURE__ */ new Set());
function N(...c) {
  if (process.env.NODE_ENV !== "production") {
    const e = c.join(" ");
    D.has(e) || (D.add(e), console.error(`Base UI: ${e}`));
  }
}
function C(c) {
  const {
    focusableWhenDisabled: e,
    disabled: a,
    composite: i = !1,
    tabIndex: s = 0,
    isNativeButton: n
  } = c, u = i && e !== !1, d = i && e === !1;
  return {
    props: l.useMemo(() => {
      const f = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(o) {
          a && e && o.key !== "Tab" && o.preventDefault();
        }
      };
      return i || (f.tabIndex = s, !n && a && (f.tabIndex = e ? s : -1)), (n && (e || u) || !n && a) && (f["aria-disabled"] = a), n && (!e || d) && (f.disabled = a), f;
    }, [i, a, e, u, d, n, s])
  };
}
function F(c = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: a,
    tabIndex: i = 0,
    native: s = !0
  } = c, n = l.useRef(null), u = k(!0) !== void 0, d = w(() => {
    const o = n.current;
    return !!((o == null ? void 0 : o.tagName) === "A" && (o != null && o.href));
  }), {
    props: p
  } = C({
    focusableWhenDisabled: a,
    disabled: e,
    composite: u,
    tabIndex: i,
    isNativeButton: s
  });
  return process.env.NODE_ENV !== "production" && l.useEffect(() => {
    if (!n.current)
      return;
    const o = n.current.tagName === "BUTTON";
    s ? o || N("A component that acts as a button was not rendered as a native <button>, which does not match the default. Ensure that the element passed to the `render` prop of the component is a real <button>, or set the `nativeButton` prop on the component to `false`.") : o && N("A component that acts as a button was rendered as a native <button>, which does not match the default. Ensure that the element passed to the `render` prop of the component is not a real <button>, or set the `nativeButton` prop on the component to `true`.");
  }, [s]), T(() => {
    const o = n.current;
    o instanceof HTMLButtonElement && u && e && p.disabled === void 0 && o.disabled && (o.disabled = !1);
  }, [e, p.disabled, u]), {
    getButtonProps: l.useCallback((o = {}) => {
      const {
        onClick: r,
        onMouseDown: b,
        onKeyUp: m,
        onKeyDown: h,
        onPointerDown: E,
        ...g
      } = o;
      return K({
        type: s ? "button" : void 0,
        onClick(t) {
          if (e) {
            t.preventDefault();
            return;
          }
          r == null || r(t);
        },
        onMouseDown(t) {
          e || b == null || b(t);
        },
        onKeyDown(t) {
          if (e || (B(t), h == null || h(t)), t.baseUIHandlerPrevented)
            return;
          const P = t.target === t.currentTarget && !s && !d() && !e, y = t.key === "Enter", I = t.key === " ";
          P && ((I || y) && t.preventDefault(), y && (r == null || r(t)));
        },
        onKeyUp(t) {
          e || (B(t), m == null || m(t)), !t.baseUIHandlerPrevented && t.target === t.currentTarget && !s && !e && t.key === " " && (r == null || r(t));
        },
        onPointerDown(t) {
          if (e) {
            t.preventDefault();
            return;
          }
          E == null || E(t);
        }
      }, s ? void 0 : {
        role: "button"
      }, p, g);
    }, [e, p, s, d]),
    buttonRef: n
  };
}
export {
  F as u
};
